import { render } from "./shop-sidebar-sizes.vue?vue&type=template&id=2bc57f79&scoped=true"
import script from "./shop-sidebar-sizes.vue?vue&type=script&lang=js"
export * from "./shop-sidebar-sizes.vue?vue&type=script&lang=js"

import "./shop-sidebar-sizes.vue?vue&type=style&index=0&id=2bc57f79&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bc57f79"]])

export default __exports__